export const COLUMN_EVENT_TYPE = {
  RESIZE: 'resize',
  DISPLAY: 'display',
  SORT: 'sort',
  ORDER: 'order',
  RESET: 'reset',
} as const;

export const DETAIL_ROW_KEY = 'detail' as const;
